/**
 * Session storage for preserving redirect URL across the Google OAuth flow.
 * Google OAuth doesn't allow dynamic query params in redirect URIs, so we store
 * the intended redirect URL in sessionStorage before redirecting to Google,
 * then retrieve it after the OAuth callback.
 */

const STORAGE_KEY = 'ld_google_oauth_redirect';

/**
 * Returns the stored Google OAuth redirect path, or null if none or unavailable.
 */
export function getGoogleOAuthRedirect(): string | null {
  try {
    return sessionStorage.getItem(STORAGE_KEY);
  } catch {
    return null;
  }
}

/**
 * Stores the redirect path to use after the Google OAuth callback.
 * Call before redirecting to Google. No-op if sessionStorage is unavailable.
 */
export function setGoogleOAuthRedirect(path: string): void {
  try {
    sessionStorage.setItem(STORAGE_KEY, path);
  } catch {
    // sessionStorage may be unavailable in some contexts (e.g., private browsing)
  }
}

/**
 * Removes the stored redirect. Call after consuming it on the OAuth callback.
 */
export function removeGoogleOAuthRedirect(): void {
  try {
    sessionStorage.removeItem(STORAGE_KEY);
  } catch {
    // sessionStorage may be unavailable
  }
}
